import DataSetProvider from '@components/DataSetProvider';
import Date from '@components/Date';
import Image from '@components/Image';
import Link from '@components/Link';
import MainMarker from '@components/Marker/MainMarker';
import SubMarker from '@components/Marker/SubMarker';
import type DataSet from '@interfaces/DataSet';
import type {Post as PostType} from '@interfaces/Post';
import classNames from 'classnames';
import type {ReactElement} from 'react';

interface Props {
    postData: PostType;
    className?: string;
    withTag?: boolean;
    withDescription?: boolean;
    ioName?: string;
    forcedSmall?: boolean;
    dataSet?: DataSet;
}

export default function Post({postData, ...props}: Props): ReactElement<Props> {
    const classes = classNames({
        post: true,
        'post--big': !props.forcedSmall && postData.forcedBig,
        [props.className!]: props.className,
        [postData.className!]: postData.className,
    });

    return (
        <DataSetProvider dataSet={props.dataSet}>
            {(dataSet: DataSet) => (
                <div
                    className={classes}
                    data-vr-contentbox={props.ioName}
                    data-vr-contentbox-url={postData.link}
                    {...dataSet}
                >
                    {postData.image ? (
                        <div className="post__img">
                            <Link to={postData.link} className="js-track-text-widget-photo">
                                <Image
                                    src={postData.image.source}
                                    srcset={postData.image.srcset}
                                    sizes={postData.image.sizes}
                                />
                            </Link>
                        </div>
                    ) : null}
                    <div className="post__info">
                        {props.withTag !== false && postData.tag ? (
                            <MainMarker
                                {...postData.tag}
                                className="post__tag"
                                linkClassName="js-track-text-widget-tag"
                                ioName={props.ioName ? `Тег – ${props.ioName}` : ''}
                            />
                        ) : null}
                        {postData.time ? (
                            <Date time={postData.time} className="post__date" />
                        ) : null}
                        {props.withTag !== false && postData.subtag ? (
                            <SubMarker
                                {...postData.subtag}
                                className="post__subtag"
                                linkClassName="js-track-text-widget-subtag"
                                ioName={props.ioName ? `Подтег – ${props.ioName}` : ''}
                            />
                        ) : null}
                        <Link
                            to={postData.link}
                            className="post__bottom-link js-track-text-widget-title"
                        >
                            <div className="post__title" data-vr-headline>
                                {postData.title}
                            </div>
                            {props.withDescription && postData.contents ? (
                                <div
                                    className="post__description"
                                    dangerouslySetInnerHTML={{__html: postData.contents}}
                                />
                            ) : null}
                            {postData.logo ? (
                                <img
                                    className="post__logo"
                                    src={postData.logo}
                                    width="140"
                                    height="15"
                                    loading="lazy"
                                    alt="logo"
                                />
                            ) : null}
                        </Link>
                    </div>
                </div>
            )}
        </DataSetProvider>
    );
}
